import React from 'react'
import WorkWithUs from './WorkWithUs'

function Contact(props) {
  return (
    <WorkWithUs api={props.api} acctok={props.acctok} css={'contact-us-page'} />
  )
}

export default Contact